export default __webpack_public_path__ + "static/media/barbarianmark.27179cc5.gif";